import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { DEG_TO_RAD, Point, Sprite } from "pixi.js";
import tools from "tools";
export default class Particules {
  constructor(tint, center, nbr, particulesContainer, radius, scale, colors) {
    this.update = this.update.bind(this);
    this.animate = this.animate.bind(this);
    this._particulesContainer = particulesContainer;
    this._particulesArr = [];
    this._center = center;
    this.__gravity = new Point(0, 0);
    this._radius = radius || 5;
    this._pos = null;
    this._angleInc = 360 / nbr;
    this._angle = 0;
    let texture = assets.textures.frag0.texture;
    let colorId = 0;
    for (let i = 0; i < nbr; i++) {
      // const fragId = parseInt(tools.range(0, 5.9999));

      const particule = new Sprite(texture);
      particule.anchor.set(.5);
      particule.scale.set(tools.range(.3, 1) * (scale || config.particuleScale));
      particule.tint = colors ? colors[colorId] : tint;
      if (colors) {
        if (colorId < colors.length - 1) {
          colorId++;
        } else {
          colorId = 0;
        }
      }
      particule.rotation = Math.random() * 360 * DEG_TO_RAD;
      particule.rotationVal = Math.random() > .49 ? -Math.random() * DEG_TO_RAD * 10 : Math.random() * DEG_TO_RAD * 10;
      this._angle += this._angleInc;
      this._pos = tools.angle2pos({
        x: 0,
        y: 0
      }, this._radius * Math.random(), this._angle);
      particule.__x = this._pos.x * 1.5;
      particule.__y = this._pos.y;
      particule.x = this._pos.x + this._center.x;
      particule.y = this._pos.y + this._center.y;

      // this._particulesContainer.addChild(particule);
      this._particulesArr.push(particule);
      this._animate = false;
      // if (fragId >= fragIdArr.length - 1) {
      //     fragId = 0;
      // } else {
      //     fragId++;
      // }
    }
  }
  set force(val) {
    return this._force = val;
  }
  set gravity(val) {
    return this._gravity = val;
  }
  get destroyed() {
    return this._destroyed;
  }
  setDispose(arr, id) {
    this.__id = id;
    this.parentArray = arr;
  }
  animate() {
    for (let i = 0; i < this._particulesArr.length; i++) {
      this._particulesContainer.addChild(this._particulesArr[i]);
      gsap.to(this._particulesArr[i].scale, {
        delay: tools.range(.1, .5),
        duration: .7,
        x: 0,
        y: 0
      });
    }
    this._animate = true;
    gsap.ticker.add(this.update);
  }
  update() {
    if (config.pause) {
      return;
    }
    if (this._animate) {
      let speedx = 7;
      let speedy = 10;
      for (let i = 0; i < this._particulesArr.length; i++) {
        this.__gravity.x += this._gravity.x;
        this.__gravity.y += this._gravity.y;
        const element = this._particulesArr[i];
        element.__x *= this._force.x;
        element.__y *= this._force.y;
        element.__x += this.__gravity.x;
        element.__y += this.__gravity.y;
        element.x = element.__x * speedx + this._center.x;
        element.y = element.__y * speedy + this._center.y;
        element.rotation += element.rotationVal;
        if (element.y > config.view.y - 10 || element.x < 10 || element.x > config.view.x - 10) {
          this._particulesContainer.removeChild(element);
          tools.spliceByElement(element, this._particulesArr);
          element.destroy({
            children: true
          });
        }
      }
      if (this._particulesArr.length <= 0) {
        this._animate = false;
        gsap.ticker.remove(this.update);
      }
    }
  }
}
